import { render, staticRenderFns } from "./chat.vue?vue&type=template&id=69339910&scoped=true&"
import script from "./chat.vue?vue&type=script&lang=js&"
export * from "./chat.vue?vue&type=script&lang=js&"
import style0 from "./chat.vue?vue&type=style&index=0&id=69339910&prod&lang=scss&scoped=true&"
import style1 from "./chat.vue?vue&type=style&index=1&id=69339910&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69339910",
  null
  
)

export default component.exports